<style scoped="scoped" lang="scss"></style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-show="false" :name="$options.name" v-bind="$attrs" ref="yt"> </yi_curd_table>
    <div class="container">
      <!-- 左侧按钮插槽 -->
      <el-button size="mini" @click="onAddData" type="primary">
        {{ $t('xinzeng') }}
      </el-button>
    </div>
    <!--    -->
    <div style="margin-top: 12px">
      <el-table class="tables" :data="tableData.slice((pagination.currentPage - 1) * pagination.pageSize, pagination.currentPage * pagination.pageSize)" :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', 'font-size': '14px', height: '48px', padding: '0px' }" :show-overflow-tooltip="true" size="mini" border stripe max-height="600">
        <el-table-column prop="eqmuments" :label="$t('shebeimingcheng')" width="280" :show-overflow-tooltip="true"> </el-table-column>
        <el-table-column prop="basePoint" :label="$t('jizhundian')" :show-overflow-tooltip="true"> </el-table-column>
        <el-table-column :label="$t('caozuo')" fixed="right" :show-overflow-tooltip="true" width="150">
          <template slot-scope="scope">
            <span style="color:#1894ec;font-size: 14px;font-family: Microsoft YaHei UI;" @click="edit(scope.row, scope.$index)">{{ $t('bianji') }}</span>
            <span style="color:#F56C6C;font-size: 14px;font-family: Microsoft YaHei UI;margin-left: 8px" @click="deleteRow(scope.$index, scope.row)">{{ $t('shanchu') }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div ref="pagination" style="padding-top: 10px;padding-bottom: 20px;">
        <el-pagination v-if="tableData.length > 0" style="display: flex;float: right;" background size="mini" :current-page="pagination.currentPage" :page-sizes="[10, 20, 100, 500]" :pagerCount="5" :page-size="pagination.pageSize" layout="total,sizes,prev,pager,next" :total="tableData.length" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
    </div>
    <!--新增弹窗-->
    <el-dialog :show-close="true" :title="$t('peizhixianshilie')" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false" append-to-body="append-to-body" @closed="tempEquipmentId = undefined">
      <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth" :model="currentItem" :rules="rules">
        <el-form-item :label="$t('shebeimingcheng')" required prop="equipmentId">
          <el-select :max="1" filterable :clearable="true" v-model="currentItem.equipmentId" @change="changeEqName">
            <el-option v-for="(item, index) in eqList" :key="index" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('jizhundian')" required prop="basePoint">
          <el-input v-model="currentItem.basePoint" oninput="value=value.replace(/^0|[^0-9]/g, '').substr(0, 50)" :value="computedValue"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">{{ $t('quxiao') }}</el-button>
        <el-button :loading="yt.editObj.loading" size="mini" type="primary" @click="saveFrame()">
          {{ $t('baocun') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'web_early_warning_management_alert_settings_move_list',
  props: ['changeTypeIds'],
  data() {
    return {
      currentItemIndex: null,
      sign: '',
      tableData: [],
      changeValue: null,
      setEq: '',
      tempEquipmentId: undefined,
      eqList: [],
      equmentName: '',
      currentItem: {
        equipmentId: '',
        basePoint: '100'
      },
      pagination: {
        currentPage: 1,
        pageSize: 10
      },
      codeName: null,
      dialogVisible: false,
      dialogVisibleItem: false,
      isEdit: false,
      rules: {
        equipmentId: [{ required: true, message: '必填' }],
        basePoint: [{ required: true, message: '必填' }]
      }
    };
  },
  computed: {
    computedValue() {
      return this.currentItem.basePoint;
    }
  },
  watch: {
    changeTypeId: {
      handler(n, o) {
        if (n) {
          this.codeName = n;
        }
        console.log('changeTypeIdvalue', n);
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    onClose() {
      for (let i = 0; i < this.tableData.length; i++) {
        this.tableData[i].id = i + 1;
      }
    },
    onAddData() {
      this.isEdit = false;
      // this.currentItem = {}
      this.currentItem.id = '';
      this.currentItem.basePoint = '';
      this.currentItem.equipmentId = '';
      this.currentItem.basePoint = 100;
      this.dialogVisible = true;
      this.getEquipmentList();
    },
    edit(row, index) {
      this.isEdit = true;
      this.sign = 1;
      this.currentItem = { ...row };
      this.dialogVisible = true;
      this.tempEquipmentId = row.equipmentId;
    },
    // 删除行
    deleteRow(index, row) {
      this.$confirm(this.$t('shanchujiangbukehuifu,shifoujixu?'), {
        confirmButtonText: this.$t('shanchu'),
        cancelButtonText: this.$t('quxiao'),
        type: 'warning'
      })
        .then(() => {
          this.tableData.splice(index, 1);
        })
        .catch(() => {});
    },
    /**
     * 页码
     * @param val
     */
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
    },
    /**
     * 分页
     * @param val
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
    },
    getEquipmentList() {
      this.http
        .get('/web/equipment/standing_book/page', {
          params: {
            pageNum: 1,
            pageSize: 999
          }
        })
        .then(res => {
          this.eqList = res.data.rows;
        });
    },
    changeEqName(value) {
      let foundItem = this.eqList.find(item => item.id === value);
      if (foundItem) {
        this.equmentName = foundItem.name;
      }
    },

    saveFrame() {
      let hasExist = [];
      if (this.currentItem.id) {
        // 编辑
        hasExist = this.tableData.filter(item => {
          return item.equipmentId === this.currentItem.equipmentId && item.id !== this.currentItem.id;
        });
      } else {
        // 新增
        hasExist = this.tableData.filter(item => {
          return item.equipmentId === this.currentItem.equipmentId;
        });
      }
      if (hasExist.length > 0) {
        this.$message.error(this.$t('yicunzaixiangtongshebei'));
        return;
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          if (!this.currentItem.id) {
            this.tableData.push({
              id: this.tableData.length + 1,
              ...this.currentItem,
              eqmuments: this.equmentName
            });
          } else {
            for (let i = 0; i < this.tableData.length; i++) {
              if (this.tableData[i].id === this.currentItem.id) {
                if (this.equmentName && this.tableData[i].equipmentId !== this.currentItem.equipmentId) {
                  this.tableData[i].eqmuments = this.equmentName;
                }
                this.tableData[i].equipmentId = this.currentItem.equipmentId;
                this.tableData[i].basePoint = this.currentItem.basePoint;
                break;
              }
            }
          }
          this.dialogVisible = false;
          this.equmentName = '';
          if (this.tableData.length > 0) {
            for (let i = 0; i < this.tableData.length; i++) {
              this.tableData[i].id = i + 1;
            }
          }
        }
      });
    }
  }
};
</script>
